import React from 'react';
import { Paper, Title, Text, Group, Stack, Badge, Button, Divider } from '@mantine/core';
import { IconCreditCard, IconSettings } from '@tabler/icons-react';
import moment from 'moment';
import { useSalon } from '../../context/SalonContext';
import { useMediaQuery } from '@mantine/hooks';
const STRIPE_BILLING_URL = process.env.REACT_APP_STRIPE_BILLING_URL

function BillingSettings() {
    const { businessInfo, currentUser } = useSalon();
    const isMobile = useMediaQuery('(max-width: 768px)');
    const getStatusColor = (status) => {
        switch (status) {
        case 'Active':
            return 'green';
        case 'Trial':
            return 'violet';
        case 'Inactive':
            return 'red';
        default:
            return 'gray';
        }
    };

    const formatTrialEndDate = (date) => {
        return moment(date).format('MMMM Do, YYYY');
    };

    const shouldShowTrialDate = () => {
        if (!businessInfo?.free_trial_end_date) return false;
        
        const isActive = businessInfo.status === 'Active';
        const trialEndDate = moment(businessInfo.free_trial_end_date);
        const today = moment().startOf('day');
        
        // For Active status, only show if trial end date is today or in the past
        if (isActive) {
        return trialEndDate.isAfter(today);
        }
        
        // For all other statuses, always show trial end date
        return true;
    };

    const handleManageSubscription = () => {
        const encodedEmail = encodeURIComponent(currentUser?.email);
        window.open(
        `${STRIPE_BILLING_URL}?prefilled_email=${encodedEmail}`,
        '_blank'
        );
    };

    return (
        <Paper p={{ base: 'sm', sm: 0 }} radius="md" withBorder={isMobile}>
            <Group position="apart" mb="md">
                <Group>
                <IconCreditCard size={isMobile ? 16 : 24} />
                <Title order={3} size={isMobile ? 'lg' : 'xl'}>Billing Status</Title>
                </Group>
            </Group>

            <Stack>
                <Group gap="sm">
                <Text fw={600}>Current Status</Text>
                <Badge color={getStatusColor(businessInfo?.status)}>
                    {businessInfo?.status}
                </Badge>
                </Group>

                {shouldShowTrialDate() && (
                <Group gap="sm">
                    <Text fw={600}>Free trial ends on</Text>
                    <Text>{formatTrialEndDate(businessInfo?.free_trial_end_date)}</Text>
                </Group>
                )}

                {businessInfo?.status === 'Active' && (
                    <>
                        <Divider />
                        <Stack>
                            <Text fw={600}>View and update your subscription details by clicking the button below.</Text>
                            <Text fw={600}>You can also view and download your invoices in the Subscription Management page.</Text>
                        </Stack>
                        <Button
                            onClick={handleManageSubscription}
                            size="lg"
                            variant="light"
                            color="violet"
                            fullWidth
                            leftSection={<IconSettings size={20} />}
                            >
                        Manage Existing Subscription
                        </Button>
                    </>
                )}
            </Stack>
        </Paper>
    );
}

export default BillingSettings; 